/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MergeSourcesRequest
 */
export interface MergeSourcesRequest {
    /**
     * The ID of the source that survives the merge
     * @type {string}
     * @memberof MergeSourcesRequest
     */
    source_to_keep_id: string;
}

/**
 * Check if a given object implements the MergeSourcesRequest interface.
 */
export function instanceOfMergeSourcesRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "source_to_keep_id" in value;

    return isInstance;
}

export function MergeSourcesRequestFromJSON(json: any): MergeSourcesRequest {
    return MergeSourcesRequestFromJSONTyped(json, false);
}

export function MergeSourcesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MergeSourcesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'source_to_keep_id': json['source_to_keep_id'],
    };
}

export function MergeSourcesRequestToJSON(value?: MergeSourcesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'source_to_keep_id': value.source_to_keep_id,
    };
}

